import ApiService from '../common/api.service';

import {
  FETCH_ATTENDANCE, FETCH_RH_COLLABORATORS,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_ATTENDANCE](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/asistencia', data, { responseType: 'arraybuffer' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_RH_COLLABORATORS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/colaboradores', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
